// @flow
import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';

import { colors } from '../../../shared/styles';

const StyledTextArea = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & textarea {
        width: 100%;
        box-sizing: border-box;
        padding: 6px 10px;
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        font-size: 14px;
        font-family: 'Noto Sans', Arial, sans-serif;
    }

    & textarea[disabled] {
        background: ${colors.offWhiteLighter};
    }

    &.input-error {
        & label {
            color: ${colors.error.default};
        }

        & textarea {
            border-color: ${colors.error.default};
        }

        span {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }
`;

type TextInputProps = {
    disabled?: boolean,
    input: any,
    label: string,
    placeholder?: string,
    rows?: number,
    meta: any,
};

const TextInput = (props: TextInputProps) => {
    const {
        disabled,
        input,
        label,
        placeholder,
        rows,
        meta: { touched, error, submitFailed } = {},
    } = props;

    const id = shortid.generate();
    const numRows = rows || 6;

    const showError = (touched || submitFailed) && error;
    const wrapperCls = showError ? 'input-error' : '';

    return (
        <StyledTextArea className={wrapperCls}>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <textarea
                {...input}
                disabled={disabled}
                id={id}
                placeholder={placeholder}
                rows={numRows}
            />
            {showError &&
                <span>
                    {error}
                </span>}
        </StyledTextArea>
    );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/shared/forms/TextArea.js